/* Shiftella — minimal, dependency free */
(function () {
  'use strict';

  var SECTIONS = 'shiftella-cart-drawer,shiftella-header';

  function $(sel, root) { return (root || document).querySelector(sel); }

  function toast(message) {
    var el = $('.toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'toast';
      el.setAttribute('role', 'status');
      document.body.appendChild(el);
    }
    el.textContent = message;
    el.classList.add('is-visible');
    clearTimeout(el._t);
    el._t = setTimeout(function () { el.classList.remove('is-visible'); }, 2800);
  }

  /* ---------- drawers ---------- */
  function overlay() { return $('[data-overlay]'); }

  function open(selector) {
    var el = $(selector);
    if (!el) return;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    var o = overlay();
    if (o) { o.hidden = false; requestAnimationFrame(function () { o.classList.add('is-open'); }); }
    document.body.style.overflow = 'hidden';
    var f = el.querySelector('button, a, input');
    if (f) f.focus();
  }

  function closeAll() {
    document.querySelectorAll('.drawer.is-open').forEach(function (el) {
      el.classList.remove('is-open');
      el.setAttribute('aria-hidden', 'true');
    });
    var o = overlay();
    if (o) { o.classList.remove('is-open'); setTimeout(function () { o.hidden = true; }, 300); }
    document.body.style.overflow = '';
  }

  /* ---------- cart ---------- */
  function paint(sections) {
    Object.keys(sections).forEach(function (id) {
      var node = document.getElementById('shopify-section-' + id);
      if (!node || typeof sections[id] !== 'string') return;
      var wasOpen = !!node.querySelector('.drawer.is-open');
      var doc = new DOMParser().parseFromString(sections[id], 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id);
      if (!fresh) return;
      node.innerHTML = fresh.innerHTML;
      if (wasOpen) {
        var d = node.querySelector('.drawer');
        if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); }
      }
    });
  }

  function post(url, payload) {
    payload.sections = SECTIONS;
    payload.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status && data.status !== 200) throw new Error(data.description || data.message);
        if (data.sections) paint(data.sections);
        return data;
      });
  }

  function add(id, quantity, button) {
    var label = button ? button.innerHTML : null;
    if (button) { button.disabled = true; button.innerHTML = window.shiftella.strings.adding; }
    return post('/cart/add.js', { items: [{ id: Number(id), quantity: Number(quantity) || 1 }] })
      .then(function () { open('.cart-drawer'); })
      .catch(function (e) { toast(e.message || window.shiftella.strings.error); })
      .finally(function () { if (button) { button.disabled = false; button.innerHTML = label; } });
  }

  function change(key, quantity) {
    return post('/cart/change.js', { id: key, quantity: Number(quantity) })
      .then(function () { if (document.body.classList.contains('t-cart')) window.location.reload(); })
      .catch(function (e) { toast(e.message || window.shiftella.strings.error); });
  }

  /* ---------- delegated events ---------- */
  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-act]');
    if (el) {
      var act = el.getAttribute('data-act');
      if (act === 'cart') { event.preventDefault(); open('.cart-drawer'); return; }
      if (act === 'menu') { event.preventDefault(); open('.menu-drawer'); return; }
      if (act === 'close') { event.preventDefault(); closeAll(); return; }
      if (act === 'remove') { event.preventDefault(); change(el.getAttribute('data-key'), 0); return; }
      if (act === 'plus' || act === 'minus') {
        event.preventDefault();
        var q = Number(el.getAttribute('data-qty')) + (act === 'plus' ? 1 : -1);
        change(el.getAttribute('data-key'), Math.max(0, q));
        return;
      }
      if (act === 'qty-plus' || act === 'qty-minus') {
        event.preventDefault();
        var input = el.parentNode.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + (act === 'qty-plus' ? 1 : -1));
        return;
      }
      if (act === 'buy') {
        event.preventDefault();
        var form = $('[data-buy-form]');
        if (form) { form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true })); }
        return;
      }
      if (act === 'thumb') {
        event.preventDefault();
        goToSlide(Number(el.getAttribute('data-index')) || 0);
        return;
      }
    }
    if (event.target.closest('[data-overlay]')) closeAll();
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cart-form]');
    if (!form) return;
    event.preventDefault();
    var id = form.querySelector('[name="id"]');
    var qty = form.querySelector('[name="quantity"]');
    add(id.value, qty ? qty.value : 1, form.querySelector('[type="submit"]'));
  });

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  /* ---------- variant picker ---------- */
  function pickers() {
    document.querySelectorAll('[data-picker]').forEach(function (picker) {
      if (picker._bound) return;
      picker._bound = true;

      var data = picker.querySelector('[data-variants]');
      if (!data) return;
      var variants = JSON.parse(data.textContent);
      var form = document.getElementById(picker.getAttribute('data-form'));

      picker.addEventListener('change', function (e) {
        var chosen = Array.prototype.map.call(picker.querySelectorAll('[data-opt]'), function (group) {
          var input = group.querySelector('input:checked') || group.querySelector('select');
          return input ? input.value : null;
        });

        Array.prototype.forEach.call(picker.querySelectorAll('[data-opt]'), function (group, i) {
          var out = group.querySelector('[data-opt-value]');
          if (out) out.textContent = chosen[i] || '';
        });

        var match = variants.find(function (v) {
          return v.options.every(function (o, i) { return o === chosen[i]; });
        });

        var priceEl = $('[data-price]');
        var button = form ? form.querySelector('[type="submit"]') : null;
        var sticky = $('[data-sticky-btn]');
        var idInput = form ? form.querySelector('[name="id"]') : null;

        function label(text, disabled) {
          if (button) { button.textContent = text; button.disabled = disabled; }
          if (sticky) { sticky.textContent = text; sticky.disabled = disabled; }
        }

        if (!match) { label(window.shiftella.strings.unavailable, true); return; }
        if (idInput) idInput.value = match.id;

        if (priceEl && window.shiftella.priceTemplate) {
          priceEl.innerHTML = window.shiftella.priceTemplate
            .replace('__NOW__', money(match.price))
            .replace('__WAS__', match.compare_at_price > match.price ? '<s>' + money(match.compare_at_price) + '</s>' : '');
        }

        label(match.available ? window.shiftella.strings.addToCart : window.shiftella.strings.soldOut, !match.available);

        if (match.featured_media) {
          var target = document.querySelector('[data-media-id="' + match.featured_media.id + '"]');
          if (target) {
            var slides = Array.prototype.slice.call(document.querySelectorAll('[data-slide]'));
            goToSlide(slides.indexOf(target));
          }
        }

        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      });
    });
  }

  /* Rupee formatting, no decimals */
  function money(cents) {
    var n = Math.round((cents || 0) / 100);
    return window.shiftella.symbol + n.toLocaleString(window.shiftella.locale || 'en-IN');
  }


  /* ---------- product gallery ---------- */
  function goToSlide(index) {
    var rail = $('[data-rail]');
    if (!rail || index < 0) return;
    var slides = rail.querySelectorAll('[data-slide]');
    if (!slides[index]) return;
    rail.scrollTo({ left: slides[index].offsetLeft - rail.offsetLeft, behavior: 'smooth' });
    markSlide(index);
  }

  function markSlide(index) {
    document.querySelectorAll('[data-thumbs] button').forEach(function (b, i) {
      b.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
    var dots = $('[data-dots]');
    if (dots) {
      Array.prototype.forEach.call(dots.children, function (dot, i) {
        dot.classList.toggle('is-on', i === index);
      });
    }
  }

  function gallery() {
    var rail = $('[data-rail]');
    if (!rail || rail._bound) return;
    rail._bound = true;
    var timer;
    rail.addEventListener('scroll', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var index = Math.round(rail.scrollLeft / rail.clientWidth);
        markSlide(index);
      }, 80);
    }, { passive: true });
  }

  /* ---------- sticky buy bar ---------- */
  function sticky() {
    var bar = $('.sticky-buy');
    var anchor = $('[data-buy-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-visible', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -60px 0px' }).observe(anchor);
  }

  /* ---------- reveal on scroll ---------- */
  function reveals() {
    var items = document.querySelectorAll('.reveal:not(.is-in)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (i) { i.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (i) { io.observe(i); });
  }

  function init() { pickers(); gallery(); sticky(); reveals(); }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
